module.exports = __webpack_public_path__ + "img/mii-swordfighter-min.90c2c006.png";